import { jobSchema, type CompressRequestInput, type Job } from '@xphoto/shared';
import { ApiError } from '../gallery/api';
import { apiFetch } from '../lib/http';

/**
 * Client typé de la COMPRESSION SANS PERTE de la sélection. La réponse est RE-PARSÉE via
 * son schéma partagé (`jobSchema`) — « never trust the client », y compris ses propres
 * réponses.
 */

async function readJson(res: Response): Promise<unknown> {
  if (!res.ok) {
    let code = 'UNKNOWN';
    try {
      const body = (await res.json()) as { error?: { code?: string } };
      if (typeof body?.error?.code === 'string') code = body.error.code;
    } catch {
      // Corps non-JSON : on garde le code générique.
    }
    throw new ApiError(res.status, code);
  }
  return res.json();
}

/**
 * `POST /api/libraries/:id/compress` — enfile un job de compression SANS PERTE (JPEG via
 * jpegtran, PNG via optipng ; vidéos ignorées). Le corps cible une sélection d'`assetIds`
 * (ou `all: true`). Renvoie le job créé (201). Une écriture désactivée renvoie 409
 * `WRITE_DISABLED` → propagée en `ApiError` (statut 409, code WRITE_DISABLED).
 */
export async function enqueueCompress(libraryId: string, body: CompressRequestInput): Promise<Job> {
  const res = await apiFetch(`/api/libraries/${libraryId}/compress`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return jobSchema.parse(await readJson(res));
}
